import { render } from "./BaseNavigation.vue?vue&type=template&id=09a8f43f&scoped=true"
const script = {}

import "./BaseNavigation.vue?vue&type=style&index=0&id=09a8f43f&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a8f43f"]])

export default __exports__